import React from 'react';
import logo from './logo.svg';
import './App.css';
import Player from './Player';
import { artefactDemos, instruments, vibratoDemos, midiFileNameToDisplayName, instrumentIdToDisplayName } from './data';
import Introduction from './Introduction';
import { line, intersectionSpace, scrollToRef } from './layout';

const ControlFlexibility = () => {
	const topRef = React.useRef(null);
	const refDataRef = React.useRef(null);
	const artefactRef = React.useRef(null);
	const vibratoRef = React.useRef(null);
	const mixedRef = React.useRef(null);

	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'column', padding: '24px' }}>
				<h1>
					The control-synthesis approach for making expressive and controllable neural music synthesizers -
					Control flexibility
				</h1>

				{line}
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					padding: '16px',
					justifyContent: 'center',
					margin: 'auto',
				}}
			>
				<div>
					<h2 ref={topRef}>Page index</h2>

					<ul>
						{[
							{ ref: refDataRef, title: 'Excerpts from the target datasets' },

							{ ref: vibratoRef, title: 'Intermediate feature modulation: Vibrato' },
							{
								ref: mixedRef,
								title: 'Training performance and synthesis models on different data sets',
							},
						].map((section) => (
							<h3 style={{ cursor: 'pointer' }} onClick={() => scrollToRef(section.ref)}>
								{'➤ ' + section.title}
							</h3>
						))}
					</ul>
				</div>

				{intersectionSpace}
				<h2 ref={refDataRef}>Excerpts from the target datasets</h2>
				{line}
				<p style={{ maxWidth: 600 }}>These excerpts come from the datsets with which the models were trained</p>

				<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }}>
					<Player
						title={'Excerpt from the classical violin dataset'}
						midiFilePath={' '}
						audioFilePath={process.env.PUBLIC_URL + `/audio/violin2/` + 'target.wav'}
					></Player>
				</div>
				<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }}>
					<Player
						title={'Excerpt from the flute dataset'}
						midiFilePath={' '}
						audioFilePath={process.env.PUBLIC_URL + `/audio/flute2/` + 'target.wav'}
					></Player>
				</div>
				<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }}>
					<Player
						title={'Excerpt from the irish fiddle dataset'}
						midiFilePath={' '}
						audioFilePath={process.env.PUBLIC_URL + `/audio/mixed/` + 'irish_excerpt.wav'}
					></Player>
				</div>

				{intersectionSpace}
				<h2 ref={vibratoRef}>{'Intermediate feature modulation: vibrato'}</h2>
				{line}

				<p style={{ maxWidth: 600 }}>
					Here are renders of the same piece showcasing two different ways of applying vibrato to the
					performance. Admittedly, there is no perceptible difference in sound between the two methods.
				</p>
				{[{ id: 'violin2', displayName: 'Violin' }].map((ins) => (
					<React.Fragment key={ins.id}>
						{vibratoDemos.map((mf) => (
							<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }} key={mf.displayName}>
								<Player
									title={ins.displayName + ': ' + mf.displayName}
									midiFilePath={process.env.PUBLIC_URL + '/midi/' + mf.fileName}
									audioFilePath={
										mf.audioFileName
											? process.env.PUBLIC_URL + `/audio/${ins.id}/` + mf.audioFileName
											: process.env.PUBLIC_URL +
											  `/audio/${ins.id}/` +
											  mf.fileName +
											  '_generated_performance.wav'
									}
								></Player>
							</div>
						))}
					</React.Fragment>
				))}
				{intersectionSpace}
				<h2 ref={mixedRef}>{'Training performance and synthesis models on different data sets'}</h2>
				{line}
				<p style={{ maxWidth: 600 }}>
					The intended effect is to transfer the articulations from one recording to another.
				</p>
				<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }}>
					<Player
						title={'Fur elise, control model & synthesis model trained on classical violin'}
						midiFilePath={process.env.PUBLIC_URL + '/midi/' + 'original.mid'}
						audioFilePath={process.env.PUBLIC_URL + `/audio/violin2/original.mid_generated_performance.wav`}
					></Player>
				</div>
				<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }}>
					<Player
						title={
							'Fur elise, control model trained on irish fiddle & synthesis model trained on classical violin'
						}
						midiFilePath={process.env.PUBLIC_URL + '/midi/' + 'original.mid'}
						audioFilePath={process.env.PUBLIC_URL + `/audio/mixed/bv.wav`}
					></Player>
				</div>
				{intersectionSpace}
				<h2 style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => scrollToRef(topRef)}>
					Back to index ☝
				</h2>
			</div>
		</>
	);
};

export default ControlFlexibility;
